import featureFlagsSource from '@/config/feature-flags.json'
import { computed } from 'vue'

type FeatureFlagConfig = {
  testimonials: boolean
  contactForm: boolean
  termsOfService: boolean
  tokenVerification: boolean
  diagnostics: boolean
}

type FeatureFlagName = keyof FeatureFlagConfig

const normalize = (value: unknown): boolean => value === true

const normalizedFlags: FeatureFlagConfig = Object.freeze({
  testimonials: normalize((featureFlagsSource as Record<string, unknown>).testimonials),
  contactForm: normalize((featureFlagsSource as Record<string, unknown>).contactForm),
  termsOfService: normalize((featureFlagsSource as Record<string, unknown>).termsOfService),
  tokenVerification: normalize((featureFlagsSource as Record<string, unknown>).tokenVerification),
  diagnostics: normalize((featureFlagsSource as Record<string, unknown>).diagnostics)
})

export const FEATURE_FLAGS = normalizedFlags

export const isFeatureEnabled = (flag: FeatureFlagName): boolean => FEATURE_FLAGS[flag]

export const useFeatureFlag = (flag: FeatureFlagName) => computed(() => isFeatureEnabled(flag))

export type { FeatureFlagName, FeatureFlagConfig }
